<template>
  <q-field
    :value="value"
    v-bind="$attrs"
    @click.native="$refs.rangePickerPopup.show()"
    @clear="$emit('input', [])"
  >
    <span
      class="flex content-center"
      :class="valueClass"
      :style="{color}"
    >{{ dateFr }}</span>
    <template #append>
      <q-icon
        name="fa fa-calendar-alt"
        class="cursor-pointer"
        :color="color"
        @click.stop
      >
        <q-popup-proxy
          ref="rangePickerPopup"
          transition-show="scale"
          transition-hide="scale"
        >
          <q-date
            ref="rangePicker"
            :value="vRange"
            range
            :mask="$options.MASK"
            today-btn
            @input="onInput"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-field>
</template>

<script>
import { DATE_ISO } from '@/consts/date'
import { dateFormatFr, parseIso } from '@/utils/data/date'
import autoDefaultModelMixin from '@/mixins/autoDefaultModelMixin'
import validateProxyMixin from '@/mixins/validateProxyMixin'

export default {
  name: 'LwfDateRangePicker',
  mixins: [autoDefaultModelMixin, validateProxyMixin],
  inheritAttrs: false,
  MASK: DATE_ISO,
  props: {
    color: {
      type: String,
      default: undefined
    },
    /**
     * @model
     */
    value: {
      type: Array,
      default: _.stubArray
    },
    valueClass: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    vRange () {
      const [from, to] = this.value
      return from === to
        ? from
        : {
          from,
          to
        }
    },
    dateFr () {
      return this.value.map((v) => {
        return v
          ? dateFormatFr(parseIso(v))
          : ''
      }).join(' - ')
    }
  },
  methods: {
    onInput (range) {
      this.$emit('input', range
        ? typeof range === 'string'
          ? [range, range]
          : [range.from, range.to]
        : [])
    }
  }
}
</script>

<style scoped>

</style>
